import * as Yup from 'yup';
import { IEntity } from '../../../../../../interfaces/IEntity';

export const initialValues: IEntity = {
	name: '',
	address: '',
	signatoryName: '',
	signatoryEmail: '',
	signatoryTitle: '',
	coiDocs: [],
	user: null,
};

export const schema = Yup.object({
	name: Yup.string().required('Required'),
	address: Yup.string().required('Required'),
	signatoryName: Yup.string().required('Required'),
	signatoryEmail: Yup.string().required('Required'),
	signatoryTitle: Yup.string().required('Required'),
	user: Yup.string().required('Required'),
	coiDocs: Yup.array().min(1, 'Required'),
});
